import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const HomePage = () => import('@/views/home/HomePage.vue')
const ProfilePage = () => import('@/views/profile/ProfilePage.vue')
const ProductPage = () => import('@/views/product/ProductPage.vue')
const NewsListPage = () => import('@/views/news/NewsListPage.vue')
const NewsDetailPage = () => import('@/views/news/NewsDetailPage.vue')
const ContactPage = () => import('@/views/contact/ContactPage.vue')
const LoginPage = () => import('@/views/auth/LoginPage.vue')

const ROUTE_META = {
    showInNav: true
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
        meta: {
            ...ROUTE_META,
            title: '首页'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: ProfilePage,
        meta: {
            ...ROUTE_META,
            title: '公司简介'
        }
    },
    {
        path: '/product',
        name: 'Product',
        component: ProductPage,
        meta: {
            title: '产品介绍'
        }
    },
    {
        path: '/news',
        name: 'News',
        component: NewsListPage,
        meta: {
            ...ROUTE_META,
            title: '新闻中心'
        }
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetailPage,
        props: true,
        meta: {
            title: '新闻正文'
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactPage,
        meta: {
            ...ROUTE_META,
            title: '联系我们'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginPage,
        meta: {
            title: '登录',
            hideLayoutChrome: true
        }
    },
    {
        path: '*',
        redirect: '/'
    }
]

export default new Router({
    mode: 'history',
    routes
})
